import dynamic from 'next/dynamic'
import dynamicIconImports from 'lucide-react/dynamicIconImports'

const getIcon = (name: keyof typeof dynamicIconImports) => {
	if (!dynamicIconImports[name]) {
		throw new Error(`Undefined icon: ${name}`)
	}
	return dynamic(dynamicIconImports[name])
}

export default getIcon


export function tryGetIcon(name: unknown) {
	if (typeof name !== 'string' || !name.trim()) return null
	const key = name.trim() as keyof typeof dynamicIconImports
	if (!dynamicIconImports[key]) return null
	return dynamic(dynamicIconImports[key])
}
